import http from '@/http'

export async function getTenantPrivileges (tenantKey: string): Promise<string[]> {
  const { data } = await http.get(`/tenants/${tenantKey}/privileges`)
  return data
}
